import { render, staticRenderFns } from "./ItemName.vue?vue&type=template&id=5c922fa0&"
import script from "./ItemName.vue?vue&type=script&lang=js&"
export * from "./ItemName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports